import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DeviceAgentSerivce, getOS } from 'src/app/services/DeviceAgent.service';
import { LabelService } from 'src/app/services/label.service';

@Component({
  selector: 'app-label-dialog',
  templateUrl: './label-dialog.component.html',
  styleUrls: ['./label-dialog.component.scss'],
})
export class LabelDialogComponent implements OnInit {
  pdfUrl: any;
  loading: boolean = false;
  pdfBlobUrl: any;

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig, public sanitizer: DomSanitizer, private labelService: LabelService, private deviceAgentSerivce: DeviceAgentSerivce) { }

  ngOnInit(): void {
    this.loading = true;
    this.printShipments();
  }

  async printShipments() {
    if (getOS() === 'iOS') {
      this.deviceAgentSerivce.PrintLabelFromIOS(this.config.data.id, "label", null);
    } else {
      if (Array.isArray(this.config.data) && this.config.data.length > 1) {
        let labelFromPrint = await this.labelService.getMultipleLabelsV2(this.config.data)
         let pdfblob = await this.base64ToBlob(labelFromPrint as Uint8Array) // from base64 to blob
        this.loading = false;
        this.pdfBlobUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(pdfblob)); // this.pdfUrl to be shown in html          
      } else if (Array.isArray(this.config.data) && this.config.data.length == 1) {
        let labelFromPrint = await this.labelService.getLabels(this.config.data[0]);
        let pdfblob = await this.base64ToBlob(labelFromPrint as Uint8Array) // from base64 to blob
        this.loading = false;
        this.pdfBlobUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(pdfblob)); // this.pdfUrl to be shown in html  
      } else {

        let labelFromPrint = await this.labelService.getLabels(this.config.data);
        let pdfblob = await this.base64ToBlob(labelFromPrint as Uint8Array) // from base64 to blob
        this.loading = false;
        this.pdfBlobUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(pdfblob)); // this.pdfUrl to be shown in html  

      }
      // this.labelService.getMultipleLabels(this.config.data).then((response: any) => {
      //   this.pdfBlobUrl = this.sanitizer.bypassSecurityTrustResourceUrl(response);
      //   this.loading = false;
      // });
    }
  }
  async base64ToBlob(base64: Uint8Array | Blob, mime = 'application/pdf') {
    if (typeof (base64) == typeof (Blob)) {
      let arg = (await (base64 as Blob).stream().getReader().read()).value;
      return new Blob([arg], { type: mime })
    } else {
      const byteArray = new Uint8Array(base64 as Uint8Array);
      return new Blob([byteArray], { type: mime });
    }
  }
}
